/**
 * Possible namespaces for resources
 */
export enum Namespace {
  DOMAIN = 'urn:uruk:domain:',
  REALM = 'urn:uruk:realm:',
  CUSTOM = 'urn:uruk:custom-tag:'
}
